<template lang="pug">
  .main-form-layout
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    .contain-view(v-else-if="lead")
      main-page(:lead.sync="lead")
    v-layout.my-6(v-else)
      v-row.fill-height.ma-0(align='center' justify='center')
        div.mx-auto
          v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
          p.caption This url is no longer valid
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import MainPage from '@/views/invoice/crm/MainPage.vue'
import IncomePage from '@/views/invoice/IncomePage.vue'
export default {
  name: 'InvoiceHome',
  props: ['pid'],
  components: { MainPage, IncomePage },
  data: () => ({
    isFetching: true,
    isMainPage: true,
    allowedPathAfterPaid: false,
    lead: null
  }),
  mounted () {
    const slashes = this.$route.path.toString().split('/')
    if (slashes.length > 3 && slashes[3] != '') {
      this.isMainPage = false
    }
    if (slashes.length > 3 && slashes[3].toString().includes('verify')) {
      this.allowedPathAfterPaid = true
    }
    this.fetchLead()
  },
  computed: {
    ...mapGetters({
      currency: 'currency/getCurrency'
    }),
    isEditable () {
      if (!this.lead) return false
      if (this.lead.paid) {
        return false
      }
      if (this.lead.installment && this.lead.status == 'partial_payment') {
        const slashes = this.$route.path.toString().split('/')
        if (slashes.length > 3 && slashes[3].toString().includes('pay')) {
          return true
        } else {
          return false
        }
      }
      return true
    }
  },
  methods: {
    fetchLead() {
      this.$axios.get(`/leads/${this.pid}/`)
        .then((resp) => {
          this.lead = resp.data
          this.$store.commit('currency/updateCurrency', resp.data.form.company.currency)
          Vue.prototype.$currency = this.currency
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
          this.$axios.get(`/companies/${this.lead.form.company.id}/genes/`)
            .then((resp) => {
              const contracts = ['YZ_FREE', 'YZ_FREE_V2', 'YZ_PERSONAL', 'YZ_BIZ', 'YZ_INTEL', 'YBOOKS_NORMAL', 'YZ_START', 'YZ_GROWTH', 'YZ_LANDING_PAGE', 'YD_FREE']
              const genes = resp.data.map(gene => gene.feature)
              var included = contracts.some(contract => genes.includes(contract))
              if (!included) {
                this.lead = null
              }
            })
            .catch(() => {})
        })
    }
  }
}
</script>

<style>
</style>
